import {Navigate, Route} from "react-router-dom";
import * as React from "react";
import {EmployeeLayout} from "./pages/employee/layout";
import {EmployeePage} from "./pages/employee";
import {EmployeeDirectoryPage} from "./pages/employee/directory";
import {EmployeeInfoPage} from "./pages/employee/info";
import {EmployeePayrollPage} from "./pages/employee/payroll";
import {EmployeeVacationPage} from "./pages/employee/vacation";
import {EmployeeHolidaysPage} from "./pages/employee/holidays";
import {VacationValidationPage} from "./pages/employee/vacation_validation";
import {EmployeeDocumentListPage} from "./pages/employee/document";
import EmployeeUploadsPage from "./pages/employee/uploads";
import {EmployeeLearningPage} from "./pages/employee/learning";
import {EmployeeEvaluationPage} from "./pages/employee/evaluation";
import {EmployeeWorkBooking} from "./pages/employee/workbooking";
import EmployeeWikiRender from "./pages/employee/wiki";
import SideBarItem from "./sidebar_item";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import {AccountCircle, Bathtub, Description, Euro, Payment} from "@mui/icons-material";
import GroupsIcon from "@mui/icons-material/Groups";
import StyleIcon from "@mui/icons-material/Style";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import SchoolIcon from "@mui/icons-material/School";
import FolderIcon from "@mui/icons-material/Folder";
import {useAuthManager} from "./components/utils/auth";
import {EmployeeProductivityPage} from "./pages/employee/productivity";
import {EmployeeTimeClockPage} from "./pages/employee/timeclock";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventIcon from "@mui/icons-material/Event";


const EmployeeRoutes = () => {
	return (
		<Route path="/app/employee" element={<EmployeeLayout/>}>
			<Route index element={<EmployeePage/>}/>
			<Route path="/app/employee/timeclock" element={<EmployeeTimeClockPage/>}/>
			{/* La primera dirección, en correos ya enviados y en la app instalada (#13832) */}
			<Route path="/app/employee/fichar" element={<Navigate to="/app/employee/timeclock" replace/>}/>
			<Route path="/app/employee/directory" element={<EmployeeDirectoryPage/>}/>
			<Route path="/app/employee/info" element={<EmployeeInfoPage/>}/>
			<Route path="/app/employee/payroll" element={<EmployeePayrollPage/>}/>
			<Route path="/app/employee/vacation" element={<EmployeeVacationPage/>}/>
			<Route path="/app/employee/holidays" element={<EmployeeHolidaysPage/>}/>
			<Route path="/app/employee/vacation-validation" element={<VacationValidationPage/>}/>
			<Route path="/app/employee/productivity" element={<EmployeeProductivityPage/>}/>
			<Route path="/app/employee/document" element={<EmployeeDocumentListPage/>}/>
			<Route path="/app/employee/uploads" element={<EmployeeUploadsPage/>}/>
			<Route path="/app/employee/learning" element={<EmployeeLearningPage/>}/>
			<Route path="/app/employee/evaluation" element={<EmployeeEvaluationPage/>}/>
			<Route path="/app/employee/workbooking" element={<EmployeeWorkBooking/>}/>
			<Route path="/app/employee/wiki/:section/:code" element={<EmployeeWikiRender/>}/>
		</Route>
	);
}

export default EmployeeRoutes;

export interface EmployeeMenuProps {
	forceEvaluation: boolean,
}

export const EmployeeMenu = ({forceEvaluation}: EmployeeMenuProps) => {
	const authManager = useAuthManager();

	return (
		<>
			{/* Fichar es obligación legal: siempre visible, también con la evaluación pendiente (#13709) */}
			<SideBarItem
				href={"/app/employee/timeclock"}
				label={"Fichar"}
				icon={<AccessTimeIcon/>}
			/>
			{!forceEvaluation && (
				<>
					{(authManager.hasBudget()) && (
						<SideBarItem
							href={"/app/employee/productivity"}
							label={"Productividad"}
							icon={<Euro/>}
						/>
					)}
					<SideBarItem
						href={"/app/employee/info"}
						label={"Mis datos"}
						icon={<AccountCircle/>}
					/>
					{/* no es listado */}
					<SideBarItem
						href={"/app/employee/payroll"}
						label={"Nóminas"}
						icon={<Payment/>}
					/>
					<SideBarItem
						href={"/app/employee/vacation"}
						label={"Tus Ausencias"}
						icon={<Bathtub/>}
					/>
					<SideBarItem
						href={"/app/employee/holidays"}
						label={"Festivos"}
						icon={<EventIcon/>}
					/>
					{authManager.isManager() && (
						<SideBarItem
							href={"/app/employee/vacation-validation"}
							label={"Validación de ausencias"}
							icon={<GroupsIcon/>}
						/>
					)}

					<SideBarItem
						href={"/app/employee/workbooking"}
						label={"Reserva la Oficina"}
						icon={<StyleIcon/>}
					/>
					<SideBarItem
						href={"/app/employee/uploads"}
						label={"Tus Documentos"}
						icon={<Description/>}
					/>
				</>
			)}
			<SideBarItem
				href={"/app/employee/evaluation"}
				label={"Tus Evaluaciones"}
				icon={<ThermostatIcon/>}
			/>
			{!forceEvaluation && (
				<>

					<SideBarItem
						href={"/app/employee/learning"}
						label={"Formación"}
						icon={<SchoolIcon/>}
					/>
					<SideBarItem
						href={"/app/employee/document"}
						label={"Documentos de Empresa"}
						icon={<FolderIcon/>}
					/>
				</>
			)}
			<SideBarItem
				href={"/app/employee/directory"}
				label={"Directorio"}
				icon={<ContactMailIcon/>}
			/>
		</>
	);
}